import { SubAPI } from "./SubAPI";
export class TableConfig extends SubAPI {
    get(input) { return this.fetcher.get("/api/table-config/get", input); }
    set(input) { return this.fetcher.post("/api/table-config/set", input); }
}
